/* original file : https://github.com/nystudio107/annotated-webpack-4-config/blob/master/src/js/app.js */

// import JS package
import Vue from 'vue';
import AOS from 'aos';
import $ from 'jquery';
import 'bootstrap';
import 'owl.carousel';
import numeral from 'numeral';
import VTooltip from 'v-tooltip';

// expose jQuery to 3rd party JS, credit : https://symfonycasts.com/screencast/javascript-webpack/global-jquery
global.jQuery = $;
global.$ = $;

// import local JS
import './theme';
import './theme-additional';
import './home';
import './expressform';
import './blitz';
import './view-count';
import './search';
import './floating_shortcut';
import './meilisearch';
import Helper from "./helper";
import Service from './service';

// to avoid content not shown, credit : https://github.com/michalsnik/aos/issues/110#issuecomment-313558842
window.addEventListener('load', AOS.refresh)
Vue.use(VTooltip);

// App main
const main = async () => {
  // Create our vue instance
  new Vue({
    el: "#footer",
    delimiters: ['${', '}'],
    data() {
      return {
        totalVisits: 0,
        topCountries: [],
      };
    },
    mounted() {
      // execute fetch google analytics data few seconds later
      setTimeout(() => {
        this.fetchData();
      }, 2000);
    },
    methods: {
      formatNumber(number = 0, numberFormat = '0,0') {
        return numeral(number).format(numberFormat);
      },
      fetchData() {
        Service.getStatistic().then((response) => {
          // exclude if country is "ZZ" or "not set"
          const topCountries = response.topCountries.filter((v) => {
            return !v.includes('ZZ') || v.includes('not set');
          });
          this.totalVisits = response.totalVisits;
          // get top 10 countries
          this.topCountries = topCountries.slice(0, 10);
        });
      },
    },
  });
};
// Execute async function
main().then((value) => {
  // initiate animate on scroll
  AOS.init();

  // sticky navbar
  window.onscroll = function () {
    var header_navbar = document.querySelector(".h14-navbar, .navbar-produk");
    var sticky = header_navbar.offsetTop;

    if (window.pageYOffset > sticky) {
      header_navbar.classList.add("fixed-top");
    } else {
      header_navbar.classList.remove("fixed-top");
    }
  };

  // show app version
  const versionEl = document.querySelector('[data-web-version]');
  if (versionEl) {
    console.info(`web version : [${versionEl.dataset.webVersion}]`);
  }
});

window.getWebVersion = Helper.getWebVersion;



// Table of Contents (moved from toc.twig)
document.addEventListener('DOMContentLoaded', function () {
  const contentRoot = document.querySelector('.js-toc-content');
  const tocRoot = document.querySelector('.toc');
  if (!contentRoot || !tocRoot || typeof window.tocbot === 'undefined') {
    return;
  }

  function slugify(text) {
    return String(text)
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-');
  }

  function addHeadingIds(root) {
    const headings = root.querySelectorAll('h2, h3, h4, h5, h6');
    const used = new Map();
    headings.forEach(el => {
      if (el.id && el.id.trim() !== '') {
        el.setAttribute('tabindex', '-1');
        used.set(el.id, (used.get(el.id) || 0) + 1);
        return;
      }
      const base = slugify(el.textContent || '');
      let id = base || 'section';
      if (used.has(id)) {
        const n = used.get(id) + 1;
        used.set(id, n);
        id = `${id}-${n}`;
      } else {
        used.set(id, 1);
      }
      el.id = id;
      el.setAttribute('tabindex', '-1');
    });
  }

  addHeadingIds(document);

  window.tocbot.init({
    tocSelector: '.toc',
    contentSelector: '.js-toc-content',
    headingSelector: 'h2, h3, h4, h5, h6',
    hasInnerContainers: true,
    isCollapsedClass: 'is-collapsed',
    collapsibleClass: 'is-collapsible',
    collapseDepth: 1,
    scrollSmooth: true,
    scrollSmoothOffset: 0,
  });

  const panel = document.getElementById('toc-panel');
  const fab = document.querySelector('.toc-fab');
  const closeBtn = document.querySelector('.toc-close');
  if (panel && fab) {
    function closePanel() {
      fab.focus();
      panel.classList.remove('is-open');
    }
    function openPanel() {
      requestAnimationFrame(() => {
        panel.classList.add('is-open');
        if (closeBtn) closeBtn.focus();
      });
    }
    function togglePanel() {
      if (panel.classList.contains('is-open')) {
        closePanel();
      } else {
        openPanel();
      }
    }

    fab.addEventListener('click', togglePanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    document.addEventListener('click', function (e) {
      const target = e.target;
      if (!panel.contains(target) && target !== fab && panel.classList.contains('is-open')) {
        closePanel();
      }
    });

    document.addEventListener('focusin', function (e) {
      if (!panel.classList.contains('is-open') && panel.contains(e.target)) {
        fab.focus();
      }
    });
  }
});